import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class MsisdnService {

  constructor(private http: HttpClient) { }
  
  public getMsisdnRangeByPagination(page: any) {
    return this.http.post<any>("/api/v1/amjam/authentication/serviceProviderMsisdnRange/getmsisdnrangebypagination", page);
  }

  public searchKey(page: any) {
    return this.http.post<any>("/api/v1/amjam/authentication/serviceProviderMsisdnRange/search", page);
  }

  public add(data: any) {
    return this.http.post<any>("/api/v1/amjam/authentication/serviceProviderMsisdnRange/add", data);
  }

  public delete(id: any) {
    return this.http.delete<any>("/api/v1/amjam/authentication/serviceProviderMsisdnRange/delete/" + id);
  }

  public update(data: any) {
    return this.http.put<any>("/api/v1/amjam/authentication/serviceProviderMsisdnRange/update/",data);
  }

  public get(id: any) {
    return this.http.get<any>("/api/v1/amjam/authentication/serviceProviderMsisdnRange/get/"+id);
  }

  public getAllServiceProviders() {
    return this.http.get<any>("/api/v1/amjam/authentication/serviceProviderMsisdnRange/serviceprovider/getall") ;
  }

  public getAllFinancialInstituitions() {
    return this.http.get<any>("/api/v1/amjam/authentication/serviceProviderMsisdnRange/financialinstitution/getall");
  }
}
